// BulkBar (drawing v2.6, list screen `.bulk`; reference section 7): navy,
// radius 10, appears once one row is selected and sticks to the top of the
// list. The count, up to three actions, More, clear. One row on a phone: the
// count, the main action, More, clear.

import type { ReactNode } from "react";
import { X } from "lucide-react";
import { IconButton } from "./IconButton";
import { cx } from "./cx";

export function BulkBar({ count, noun = "selected", actions, more, onClear, className }: { count: number; noun?: string; /** Up to three Buttons; mark the ones to hide on a phone with hideOnPhone. */ actions: ReactNode; /** The More menu. */ more?: ReactNode; onClear: () => void; className?: string }) {
  return (
    <div className={cx("pg-bulk", className)} role="region" aria-label="Bulk actions">
      <b>
        {count} {noun}
      </b>
      {actions}
      {more}
      <IconButton className="pg-bulk__x" label="Clear selection" icon={<X className="pg-ico" aria-hidden />} onClick={onClear} />
    </div>
  );
}
